export default {"src":"__ASTRO_ASSET_IMAGE__BpyDaeZj__","width":96,"height":96,"format":"png"}